import { Component, OnInit } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { TestInfoModel, TestInfoRow } from 'src/app/models/test_info_model';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-test-info',
  templateUrl: './test-info.component.html',
  styleUrls: ['./test-info.component.css']
})
export class TestInfoComponent implements OnInit {

  public testsInfo: TestInfoModel[] = []
  public testInfo: TestInfoModel = {
    type: '',
    mainDescription: '',
    link: '',
    rows: []
  }

  public editingId: string = '';
  public editingRowIndex: number = -1;

  public row: TestInfoRow = {
    imageUrl: '',
    title: '',
    description: '',
  }
  public editor:Editor;
  public html;

  constructor(
    private testService: TestService
  ) { }

  ngOnInit(): void {
    this.editor = new Editor();
    this.html = '';
    this.testService.getInfoTests({}).subscribe({
      next: (res) => {
        this.testsInfo = res;
      },
      error: (err) => {
        console.error('Error fetching test info:', err);
      }
    })
  }
  
  uploadImage(event:any){
    let image = event.target.files[0];
    this.testService.uploadImage(image).subscribe((res:any)=>{
      this.row.imageUrl = res.secure_url;
    })
  }

  selectInfo(info: any){
    let testInfo = this.testsInfo.find(x=>x.type === info);
    if (testInfo) {
      this.testInfo.mainDescription = testInfo.mainDescription;
      this.testInfo.rows = testInfo.rows || [];
      this.editingId = testInfo._id || '';
      this.testInfo.link = testInfo.link || '';
      this.html = testInfo.mainDescription;
    }else{
      this.testInfo = {
        type: info,
        mainDescription: '',
        rows: [],
        link: ''
      };
      this.editingId = '';
      this.html = '';
    }
    console.log(this.html)
  }

  create(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    this.testInfo.mainDescription = html;
    if (this.editingId){
      this.testService.updateTestInfo(this.testInfo, this.editingId).subscribe({
        next: (res) => {
          Swal.fire({
            text: 'Información actualizada correctamente',
            icon: 'success',
          })
          this.editingId = '';
          this.testInfo = {
            type: '',
            mainDescription: '',
            rows: [],
            link: ''
          };
          location.reload()
        },
        error: (err) => {
          console.error('Error updating test info:', err);
        }
      })
    }else{
      this.testService.createTestInfo(this.testInfo).subscribe({
        next: (res) => {
          Swal.fire({
            text: 'Información creada correctamente',
            icon: 'success',
          })
          this.testInfo = {
            type: '',
            mainDescription: '',
            rows: [],
            link: ''
          };
          location.reload()
        },
        error: (err) => {
          console.error('Error creating test info:', err);
        }
      });
    }
  }

  addRow(){
    if (this.editingRowIndex >= 0) {
      this.testInfo.rows[this.editingRowIndex] = this.row;
      this.editingRowIndex = -1;
    } else {
      this.testInfo.rows.push(this.row);
    }
    this.row = {
      imageUrl: '',
      title: '',
      description: '',
    };
    this.editingRowIndex = -1; // Reset editing index
    $('#row-modal').modal('hide'); // Hide the modal after adding
    console.log(this.testInfo.rows);
  }

  handleEditRow(index: number) {
    this.editingRowIndex = index;
    this.row = { ...this.testInfo.rows[index] }; // Clone the row to edit
    $('#row-modal').modal('show'); // Show the modal for editing
  }

  handleDeleteRow(index: number) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: "¡Esta acción no se puede deshacer!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.testInfo.rows.splice(index, 1);
        
      }
    })
  }

  handleAddNewRow() {
    this.editingRowIndex = -1; // Reset editing index
    this.row = {
      imageUrl: '',
      title: '',
      description: '',
    };
    $('#row-modal').modal('show'); // Show the modal for adding a new row
  }

  moveRowPosition(index: number, direction: 'up' | 'down') {
    if (direction === 'up' && index > 0) {
      const temp = this.testInfo.rows[index - 1];
      this.testInfo.rows[index - 1] = this.testInfo.rows[index];
      this.testInfo.rows[index] = temp;
    } else if (direction === 'down' && index < this.testInfo.rows.length - 1) {
      const temp = this.testInfo.rows[index + 1];
      this.testInfo.rows[index + 1] = this.testInfo.rows[index];
      this.testInfo.rows[index] = temp;
    }
  }
}
